import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerNotificationTapListener } from "./lib/push-notifications";

// Register tap listener immediately so cold-start notification taps are captured
registerNotificationTapListener();

// مع تقسيم الحزمة: متصفح فاتح نسخة قديمة وقت النشر قد يطلب جزء صفحة انحذف
// اسمه — نعيد التحميل مرة واحدة فيلتقط النسخة الجديدة بدل شاشة بيضاء.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const KEY = "chunk_reload_at";
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 30_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
